import { render, staticRenderFns } from "./often-gold-rules.vue?vue&type=template&id=411b78a8&scoped=true&"
import script from "./often-gold-rules.vue?vue&type=script&lang=js&"
export * from "./often-gold-rules.vue?vue&type=script&lang=js&"
import style0 from "./often-gold-rules.vue?vue&type=style&index=0&id=411b78a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411b78a8",
  null
  
)

export default component.exports